import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, Avatar, Typography, TextField, Button, Grid } from '@mui/material';
import axios from 'axios';

export default function UpdateCompany() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { id, name, address, email, phoneNumber, website } = state;

  const [companyName, setCompanyName] = useState(name || '');
  const [companyAddress, setCompanyAddress] = useState(address || '');
  const [companyEmail, setCompanyEmail] = useState(email || '');
  const [companyPhone, setCompanyPhone] = useState(phoneNumber || '');
  const [companyWebsite, setCompanyWebsite] = useState(website || '');

  const updateAPIData = () => {
    axios.put(`https://smartlight.bhtelecom.ba:3000/api/companies/${id}`, {
      name: companyName,
      address: companyAddress,
      email: companyEmail,
      phoneNumber: companyPhone,
      website: companyWebsite
    }).then(() => {
      navigate('/dashboard/CompaniesListAll'); // vraća na listu firmi
    });
  };

  return (
    <div style={{ 
      backgroundColor: '#0b1446',
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#1a237e', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>{name ? name[0] : "F"}</Avatar>}
            title={<Typography variant="h6">{name}</Typography>}
            subheader={<Typography variant="body2">{email}</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Naziv firme"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                  required
                />
                <TextField
                  label="Adresa"
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Email"
                  type="email"
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Telefon"
                  value={companyPhone}
                  onChange={(e) => setCompanyPhone(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Web stranica"
                  value={companyWebsite}
                  onChange={(e) => setCompanyWebsite(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              sx={{ mt: 3, backgroundColor: '#3949ab' }}
              onClick={updateAPIData}
            >
              Spasi promjene
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
